import React, { createContext, useContext, useState, useEffect } from 'react';

const QuizContext = createContext();

export function QuizProvider({ children }) {
  const [answers, setAnswers] = useState({});
  const [leadData, setLeadData] = useState({});
  const [resultType, setResultType] = useState(null);

  // Load from local storage on mount (optional, good for persistence)
  useEffect(() => {
    const saved = localStorage.getItem('rentersQuizState');
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (parsed.answers) setAnswers(parsed.answers);
        if (parsed.leadData) setLeadData(parsed.leadData);
        if (parsed.resultType) setResultType(parsed.resultType);
      } catch (e) {
        console.error("Could not parse saved quiz state");
      }
    }
  }, []);

  // Save to local storage on change
  useEffect(() => {
    localStorage.setItem('rentersQuizState', JSON.stringify({ answers, leadData, resultType }));
  }, [answers, leadData, resultType]);

  const updateAnswer = (questionId, answerId) => {
    setAnswers(prev => ({ ...prev, [questionId]: answerId }));
  };

  const submitLead = (data, calculatedResultType) => {
    setLeadData(data);
    setResultType(calculatedResultType);
    // In a real app, this is where we'd call Supabase
    console.log("Saving to DB:", { leadData: data, answers, resultType: calculatedResultType });
  };

  const resetQuiz = () => {
    setAnswers({});
    setLeadData({});
    setResultType(null);
    localStorage.removeItem('rentersQuizState');
  };

  return (
    <QuizContext.Provider value={{
      answers,
      updateAnswer,
      leadData,
      submitLead,
      resultType,
      resetQuiz
    }}>
      {children}
    </QuizContext.Provider>
  );
}

export function useQuiz() {
  return useContext(QuizContext);
}